import { useCallback, useEffect } from 'react';
import { useApiPost } from '../../api/Api.hooks';
import { useAppContext } from '../../AppContext';
import { UserDeviceDto } from '../../models/User';
import { UserDevice } from '../../models/UserDevice';

export default function useUpsertUserDevice(userId: number) {
  const { data, isLoading, error, post } = useApiPost<UserDevice>(
    `users/${userId}/push-token`
  );
  const { logError } = useAppContext();
  useEffect(
    () =>
      void (
        error && logError('Create user device permission token Error', error)
      ),
    [error, logError]
  );

  const upsertUserDevice = useCallback(
    (userPushTokenDto: UserDeviceDto) => {
      post(userPushTokenDto);
    },
    [post]
  );

  return {
    userDevice: data,
    upsertingUserDevice: isLoading,
    upsertingUserDeviceError: error,
    upsertUserDevice
  };
}
